const o = "3.6.1";
export { o as VERSION };